<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col v-if="agent" cols="2" align="start" style="align-content: center;">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="bot-image ml-auto"
                        :aspect-ratio="16/9"
                        positison="bottom"
                        contain
                    />
                </div>
            </v-col>
            <v-col align="start">
                <span :class="agent ? 'grey--text text--darken-4 grey lighten-3' : ''" :style="`float: ${agent ? 'left' : 'right'}; background-color: ${mainColor}`" class="white--text rounded-xl px-3 py-3 bubble-text"> {{ reply.message.attachment.payload.text }}</span>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col align="start" :offset="agent ? 2 : 0">
                <span
                    v-for="(button, index) in reply.message.attachment.payload.buttons"
                    :key="index"
                    style="text-transform: none;"
                >
                    <v-btn
                        v-if="button.type !== 'phone_number'"
                        color="grey lighten-2 black--text"
                        class="mx-1 my-1 rounded-xl"
                        @click="clickButton(button, button.title)"
                        style="text-transform: none;"
                        small
                    >
                        {{ button.title }}
                    </v-btn>
                    <a v-else :href="`tel:${button.payload}`">
                        <v-btn
                            color="grey lighten-2 black--text"
                            class="mx-1 my-1 rounded-xl"
                            style="text-transform: none;"
                            small
                        >
                            {{ button.title }}
                    </v-btn>
                    </a>
                </span>
                <!-- <v-btn
                    v-for="(button, index) in reply.message.attachment.payload.buttons"
                    :key="index"
                    color="grey lighten-2 black--text"
                    class="mx-1 my-1 rounded-xl"
                    @click="clickButton(button, button.title)"
                    style="text-transform: none;"
                >
                    <span v-if="button.type !== 'phone_number'">{{ button.title }}</span>
                    <a v-else :href="`tel:${button.payload}`">{{ button.title }}</a>
                </v-btn> -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
            selection: null,
        }),
        methods: {
            clickButton(button, buttonText) {
                if (button.url) {
                    window.open(button.url, '_blank', 'noreferrer');
                } else {
                    this.$emit('prepareMessage', {
                        text: button.payload,
                        freshchatAgentText: buttonText
                    })
                }
            },
        }
    }
</script>

<style scoped>
.v-slide-group__next, .v-slide-group__prev {
    min-width: 0!important;
}
a {
    text-decoration: none!important;
    color: unset!important;
}
</style>

<style scoped src="../../../node_modules/vuetify/dist/vuetify.min.css">
</style>

<style scoped src="@mdi/font/css/materialdesignicons.css">
</style>

<style>
.bot-image {
    border-radius: 50%;
}
</style>